module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAUCAYAAABxnDbHAAAAPElEQVRIx2M8J6j2n4HOgHHU0lFLqWLpw0z5Y3S39Oc1sf+jlo5aOjQtVeswp3+WYaiy/T9q6ailQ9JSAK99K6PA97AnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/bo.png
// module id = 244
// module chunks = 0